import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { setupTooltips } from "./lib/tooltips";
import { seedMockStore } from "./data/mocks/seed";

// Global CSS — load order matches the old multi-page HTML <head>
import "./styles/styles.css";
import "./styles/sections.css";
import "./styles/pages.css";
import "./styles/mobile.css";
import "./styles/animations.css";
import "./styles/tooltips.css";
import "./styles/chatbot.css";
import "./styles/auth.css";
import "./styles/portal.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

// Seed mock localStorage on boot. Idempotent — only writes missing keys.
// Always seed in hybrid mode too: cart/orders/enquiries/notifications still
// run against the mock-adapter and need their seed data + wishlist/compare.
seedMockStore();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

// Boot tooltips after first paint
if (typeof window !== "undefined") {
  setTimeout(() => setupTooltips(), 0);
}
